import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
const NotFoundPage = () => {
    const navigate = useNavigate();
    return (_jsx(Result, { status: "404", title: "404", subTitle: "Lo sentimos, la p\u00E1gina que visitaste no existe.", extra: _jsx(Button, { type: "primary", onClick: () => navigate('/dashboard'), children: "Volver al Dashboard" }) }));
};
export default NotFoundPage;
